import React from 'react'
import engagementphoto from "../images/wedding.jpeg";
import Navbar from '../inc/Navbar';
import {Link} from "react-router-dom";
import aiburoevent from "../images/aiburo.jpeg"
function Engagement() {
  return (
    <div>
        <Navbar/>
          <br/>
        <br/>
        <br/>
        <br/>
          <div className='koffee'>
                <div className='album py-1'>
                    <div className='container mt-3'>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li style={{ color: "white" }} className="breadcrumb-item"><Link to="/" style={{ color: "darkBLue" }} >Home</Link></li>
                                <li className="breadcrumb-item active" style={{ color: "darkBLue" }} aria-current="page">Aiburo Bhaat Event <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-double-right" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708" />
                                    <path fill-rule="evenodd" d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708" />
                                </svg></li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>

               <div className="album py-2">
        <div className="container">
          <div className="row">
            <div className="col-md-6 mt-3">
 <h1 className='mb-2 justify'>Wedding <b style={{color:"#3D2219"}}> Event</b></h1>
 <h3 style={{color:"#7a2204"}}><b>Wedding Aiburo Bhaat Celebration – Delicious Traditions Begin</b></h3>
 <p>Celebrate the beautiful Bengali tradition of Aiburo Bhaat with a grand and delicious feast before the wedding. This special pre-wedding event brings together family, love, and authentic cuisine to create unforgettable memories. Enjoy a variety of traditional dishes prepared with care, making the occasion truly joyful and meaningful.</p>
   
   <a href='tel: 9932362836'>Call: +91 9932362836</a>

                </div>
                  <div className="col-md-6 mt-3">
  <img src={aiburoevent} className="card-img-top" alt="wedding"/>

                </div>
                </div>
                </div>
                
            
            </div>
            <br/>
             <div className="album py-0">
                <div className="container">
               
                    <div className="row">

                        <div className="col-md-4 mt-2">
                            <img src={engagementphoto} className="card-img-top" alt="aiburoevent" />

                        </div>
                        </div>
                        </div>
                        </div>
    </div>
  )
}

export default Engagement